/* eslint quotes: 0 */

const resources = {
    dev: {
        translation: {
            navigation: {
                next: "Next",
            },
            testOverview: {
                allQuestions: "All questions",
                flagged: "Flagged",
                notAnswered: "Not answered",
            },
            timeRemaining: {
                day: "day",
                day_plural: "days",
                durationStringAndValue: "Duration: __formattedDuration__",
                timedOut: "Timed out!",
                timeRemainingStringAndValue: "Time remaining: __formattedTime__",
                unknown: "?",
                unlimited: "Unlimited",
            },
        },
    },
};

export default resources;
